//App
import { EndPointsType } from "./types/endPointTypes";
import env from "./env";
import { getContributorId } from "../../../utility/helpers/claimHelper";

const csGateway: string = env.serviceHost;
const endPoints: EndPointsType = {
  county: {
    get: (value) => `${csGateway}/system/County/GetCounty?id=${value}`,
    getCountiesView: () => `${csGateway}/system/County/GetCountiesView`,
    searchCounties: () => `${csGateway}/system/County/SearchCounties`,
    save: () => `${csGateway}/system/County/SaveCounty`,
    delete: (value) => `${csGateway}/system/County/DeleteCounty?id=${value}`,
    deActivate: (value) =>
      `${csGateway}/system/County/DeActivateCounty?id=${value}`,
    activate: (value) =>
      `${csGateway}/system/County/ActivateCounty?id=${value}`,
  },
  lookupType: {
    get: (value) => `${csGateway}/system/LookupType/GetLookupType?id=${value}`,
    getAll: () => `${csGateway}/system/LookupType/GetLookupTypes`,
    save: () => `${csGateway}/system/LookupType/SaveLookupType`,
    delete: (value) =>
      `${csGateway}/system/LookupType/DeleteLookupType?id=${value}`,
    activate: (value) =>
      `${csGateway}/system/LookupType/ActivateLookupType?id=${value}`,
    deActivate: (value) =>
      `${csGateway}/system/LookupType/DeActivateLookupType?id=${value}`,
    searchLookupType: () => `${csGateway}/system/LookupType/SearchLookupType`,
  },
  lookupValue: {
    get: (value) => `${csGateway}/system/Lookup/GetLookupValue?id=${value}`,
    getAllByLookupTypeId: () => `${csGateway}/system/Lookup/GetLookupValues`,
    getLookupValuesView: () => `${csGateway}/system/Lookup/GetLookupValuesView`,
    searchLookupValues: () => `${csGateway}/system/Lookup/SearchLookupValues`,
    save: () => `${csGateway}/system/Lookup/SaveLookupValue`,
    delete: (value) =>
      `${csGateway}/system/Lookup/DeleteLookupValue?id=${value}`,
    activate: (value) =>
      `${csGateway}/system/Lookup/ActivateLookupValue?id=${value}`,
    deActivate: (value) =>
      `${csGateway}/system/Lookup/DeActivateLookupValue?id=${value}`,
  },
  lookupGroup: {
    get: (value) =>
      `${csGateway}/system/LookupGroup/GetLookupGroup?id=${value}`,
    getAllByLookupTypeId: () =>
      `${csGateway}/system/LookupGroup/GetLookupGroups`,
    getLookupGroupsView: () =>
      `${csGateway}/system/LookupGroup/GetLookupGroupsView`,
    searchLookupGroups: () =>
      `${csGateway}/system/LookupGroup/SearchLookupGroups`,
    save: () => `${csGateway}/system/LookupGroup/SaveLookupGroup`,
    delete: (value) =>
      `${csGateway}/system/LookupGroup/DeleteLookupGroup?id=${value}`,
    activate: (value) =>
      `${csGateway}/system/LookupGroup/ActivateLookupGroup?id=${value}`,
    deActivate: (value) =>
      `${csGateway}/system/LookupGroup/DeActivateLookupGroup?id=${value}`,
  },
  state: {
    get: (id) => `${csGateway}/system/State/GetState?id=${id}`,
    getAll: () => `${csGateway}/system/State/GetStates`,
    save: () => `${csGateway}/system/State/SaveState`,
    delete: (value) => `${csGateway}/system/State/DeleteState?id=${value}`,
    activate: (value) => `${csGateway}/system/State/ActivateState?id=${value}`,
    deActivate: (value) =>
      `${csGateway}/system/Claim/DeactivateState?id=${value}`,
    getStatesView: () => `${csGateway}/system/State/GetStatesView`,
    searchStates: () => `${csGateway}/system/State/SearchStates`,
  },
  user: {
    getLookups: () => `${csGateway}/system/User/GetLookups`,
    get: (value) => `${csGateway}/system/User/GetUser?id=${value}`,
    getAll: () => `${csGateway}/system/User/GetView`,
    save: () => `${csGateway}/system/User/SaveUser`,
    deActivate: (value) =>
      `${csGateway}/system/User/DeactivateUser?id=${value}`,
    activate: (value) => `${csGateway}/system/User/ActivateUser?id=${value}`,
    delete: (value) => `${csGateway}/system/User/DeleteUser?id=${value}`,
    changePassword: () => `${csGateway}/system/User/ChangePassword`,
    resendConfirmationEmail: () =>
      `${csGateway}/system/User/ResendConfirmationEmail`,
    unlockUser: () => `${csGateway}/system/User/UnlockUser`,
    resetPassword: () => `${csGateway}/system/User/ResetPassword`,
  },
  claim: {
    get: (value) => `${csGateway}/system/Claim/GetClaim?id=${value}`,
    getClaimsView: () => `${csGateway}/system/Claim/GetClaimsView`,
    searchClaims: () => `${csGateway}/system/Claim/SearchClaims`,
    save: () => `${csGateway}/system/Claim/SaveClaim`,
    delete: (value) => `${csGateway}/system/Claim/DeleteClaim?id=${value}`,
    activate: (value) => `${csGateway}/system/Claim/ActivateClaim?id=${value}`,
    deActivate: (value) =>
      `${csGateway}/system/Claim/DeActivateClaim?id=${value}`,
  },
  setting: {
    get: (value) => `${csGateway}/system/Setting/GetSetting?id=${value}`,
    getAll: () => `${csGateway}/system/Setting/GetSettings`,
    save: () => `${csGateway}/system/Setting/SaveSetting`,
    delete: (value) => `${csGateway}/system/Setting/DeleteSetting?id=${value}`,
    activate: (value) =>
      `${csGateway}/system/Setting/ActivateSetting?id=${value}`,
    deActivate: (value) =>
      `${csGateway}/system/Setting/DeactivateSetting?id=${value}`,
    searchSettings: () => `${csGateway}/system/Setting/SearchSettings`,
  },
  role: {
    get: (value) => `${csGateway}/system/Role/GetRole?id=${value}`,
    getAll: () => `${csGateway}/system/Role/GetRoles`,
    save: () => `${csGateway}/system/Role/SaveRole`,
    delete: (value) => `${csGateway}/system/Role/DeleteRole?id=${value}`,
  },
  roleClaim: {
    getLookups: () => `${csGateway}/system/RoleClaim/GetRoleClaimLookups`,
    get: (roleId: string) =>
      `${csGateway}/system/RoleClaim/GetRoleClaims?roleId=${roleId}`,
    save: () => `${csGateway}/system/RoleClaim/SaveRoleClaim`,
  },
  userClaim: {
    getLookups: (userId: string) =>
      `${csGateway}/system/UserClaim/GetLookups?userId=${userId}`,
    get: (userId: string) =>
      `${csGateway}/system/UserClaim/GetUserClaims?userId=${userId}`,
    save: () => `${csGateway}/system/UserClaim/SaveUserClaim`,
  },
  organization: {
    getLookups: () => `${csGateway}/Organization/Organization/GetLookups`,
    get: (value) => `${csGateway}/Organization/Organization/Get?id=${value}`,
    getAll: () => `${csGateway}/Organization/Organization/Search`,
    save: () => `${csGateway}/Organization/Organization/Save`,
    delete: (value) =>
      `${csGateway}/Organization/Organization/DeleteOrganization?id=${value}`,
    activate: (value) =>
      `${csGateway}/Organization/Organization/Activate?id=${value}`,
    deActivate: (value) =>
      `${csGateway}/Organization/Organization/Deactivate?id=${value}`,
    searchOrganizations: () => `${csGateway}/Organization/Organization/Search`,
    getOrganizationLogo: (value) =>
      `${csGateway}/Organization/Organization/GetOrganizationLogo?id=${value}`,
    getOrganizationEmployeeUploadTemplate: (value) =>
      `${csGateway}/Organization/Organization/GetOrganizationEmployeeUploadTemplate?id=${value}`,
  },
  campaign: {
    getOrganizationCampaignLookups: () =>
      `${csGateway}/Organization/campaign/GetLookups`,
    getOrganizationCampaign: (value) =>
      `${csGateway}/Organization/campaign/Get?id=${value}`,
    searchOrganizationCampaign: () =>
      `${csGateway}/Organization/campaign/Search`,
    saveOrganizationCampaign: () => `${csGateway}/Organization/campaign/Save`,
    activateOrganizationCampaign: (value) =>
      `${csGateway}/Organization/campaign/Activate?id=${value}`,
    deactivateOrganizationCampaign: (value) =>
      `${csGateway}/Organization/campaign/Deactivate?id=${value}`,
    sendEmployeeMail: (value) =>
      `${csGateway}/Organization/campaign/SendEmployeeMail?campaignId=${value}`,
    searchDonors: () => `${csGateway}/Organization/campaign/SearchDonors`,
  },
    employee: {
        UploadEmployees: () => `${csGateway}/Organization/employee/UploadEmployees`,
        getFailedEmployeeUploadRequests: () =>
            `${csGateway}/Organization/Employee/GetFailedEmployeeUploadRequests`,
        getEmployee: (value) => {
            if (value === null || value === undefined || value === "") {
                value = getContributorId();
            }
            return `${csGateway}/Organization/employee/Get?id=${value}`

        },
    searchEmployee: () => `${csGateway}/Organization/employee/Search`,
    getEmployeeLookups: () => `${csGateway}/Organization/employee/GetLookups`,
    saveEmployee: () => `${csGateway}/Organization/employee/Save`,
    activateEmployee: (value) =>
      `${csGateway}/Organization/employee/Activate?id=${value}`,
    deactivateEmployee: (value) =>
      `${csGateway}/Organization/employee/Deactivate?id=${value}`,
    sendPledgeReminderMail: () =>
      `${csGateway}/Organization/employee/SendPledgeReminderMail`,
  },
  employeePledge: {
    getLookups: () =>
      `${csGateway}/Pledge/GetLookups?isActiveOnly=true&insertBlank=true`,
    get: (campaignId: string) =>
      `${csGateway}/Pledge/Get?campaignId=${campaignId}`,
    getContributor: (contributorId: string) =>
      `${csGateway}/Pledge/GetContributor?contributorId=${contributorId}`,
    save: () => `${csGateway}/Pledge/Save`,
    authenticate: () => `${csGateway}/EmployeePledge/ValidateEmployee`,
    getActivePastCampaigns: () =>
      `${csGateway}/EmployeePledge/GetActivePastCampaigns`,
  },
  report: {
    exportInvalidEmployeesImportData: () =>
      `${csGateway}/Report/ExportInvalidEmployeesImportData`,
    exportCampaigns: (payload) =>
      `${csGateway}/Report/ExportCampaigns?name=${payload?.name}&isActive=${payload?.isActive}`,
    exportContributions: (payload) => {
      const query = new URLSearchParams(
        Object.entries(payload ?? {})
          .filter(([, value]) => value !== null && value !== undefined && value !== "")
          .map(([key, value]) => [key, String(value)])
      );
      return `${csGateway}/Report/GetCampaignContributionsReportExport?${query.toString()}`;
    },
    reportGetContributionsData: () =>
      `${csGateway}/Report/GetCampaignContributionsReportData`,
    getCampaigns: () => `${csGateway}/Report/GetCampaigns`,
    getReportLookups: (organizationId) =>
      `${csGateway}/Report/GetReportLookups?organizationId=${organizationId}`,
    getCampaignDesignationsReportData: () =>
      `${csGateway}/Report/GetCampaignDesignationsReportData`,
    getCampaignDesignationsReportExport: (payload) => {
      const query = new URLSearchParams(
        Object.entries(payload ?? {})
          .filter(([, value]) => value !== null && value !== undefined && value !== "")
          .map(([key, value]) => [key, String(value)])
      );
      return `${csGateway}/Report/GetCampaignDesignationsReportExport?${query.toString()}`;
    },
    getCheckContributionReportData: () =>
      `${csGateway}/Report/GetCheckContributionReportData`,
    exportCheckContributions: (payload) =>
      `${csGateway}/Report/GetCheckContributionReportExport?campaignId=${payload?.campaignId}`,
  },
  agency: {
    getAgency: (value) => `${csGateway}/Agency/Get?id=${value}`,
    searchAgency: () => `${csGateway}/Agency/Search`,
    saveAgency: () => `${csGateway}/Agency/Save`,
    activateAgency: (value) => `${csGateway}/Agency/Activate?id=${value}`,
    deactivateAgency: (value) => `${csGateway}/Agency/Deactivate?id=${value}`,
  },
  template: {
    getEmailTemplate: (value) =>
      `${csGateway}/TemplateEmail/GetEmailTemplate?id=${value}`,
    getEmailTemplates: (payload) =>
      `${csGateway}/TemplateEmail/GetEmailTemplates?isActive=${
        payload?.isActive
      }${payload?.parentId !== null ? `&parentId=${payload.parentId}` : ``}`,
    saveEmailTemplate: () => `${csGateway}/TemplateEmail/SaveEmailTemplate`,
  },
  system: {
    getApplicationLogo: () => `${csGateway}/GetApplicationLogo`,
  },
  powerBi: {
    authenticate: (dashboardId) =>
      `${csGateway}/Admin/PowerBi/Authenticate?dashboardId=${dashboardId}`,
  },
};
export default endPoints;
